/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Novelist API
 * Admin REST API
 * OpenAPI spec version: 9999eb1d882990f19e352fba26b6c3f62977c8a7
 */

/**
 * What a row of a royalty export is: one invoice line, or one day behind it.
 */
export type RoyaltyExportGranularity = typeof RoyaltyExportGranularity[keyof typeof RoyaltyExportGranularity];


export const RoyaltyExportGranularity = {
  daily: 'daily',
  monthly: 'monthly',
} as const;
